(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/classCallCheck", "@babel/runtime/helpers/createClass", "@babel/runtime/helpers/defineProperty"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/classCallCheck"), require("@babel/runtime/helpers/createClass"), require("@babel/runtime/helpers/defineProperty"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.classCallCheck, global.createClass, global.defineProperty);
    global.embeddedMessageProcessor = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _classCallCheck2, _createClass2, _defineProperty2) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.EmbeddedMessagingProcessor = void 0;
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  var EmbeddedMessagingProcessor = _exports.EmbeddedMessagingProcessor = /*#__PURE__*/function () {
    function EmbeddedMessagingProcessor(currentMessages, fetchedMessages) {
      (0, _classCallCheck2["default"])(this, EmbeddedMessagingProcessor);
      (0, _defineProperty2["default"])(this, "currentMessages", void 0);
      (0, _defineProperty2["default"])(this, "fetchedMessages", void 0);
      this.currentMessages = currentMessages; // old messages
      this.fetchedMessages = fetchedMessages; // all messages
    }
    (0, _createClass2["default"])(EmbeddedMessagingProcessor, [{
      key: "processedMessagesList",
      value: function processedMessagesList() {
        return this.fetchedMessages;
      }
    }, {
      key: "newlyRetrievedMessages",
      value: function newlyRetrievedMessages() {
        return this.getNewMessages();
      }
    }, {
      key: "getNewMessages",
      value: function getNewMessages() {
        var _this = this;
        return this.fetchedMessages.filter(function (messageInfo) {
          return !_this.getCurrentMessageIds().includes(messageInfo.metadata.messageId);
        });
      }
    }, {
      key: "getCurrentMessageIds",
      value: function getCurrentMessageIds() {
        return this.currentMessages.map(function (messageInfo) {
          return messageInfo.metadata.messageId;
        });
      }
    }, {
      key: "getFetchedMessageIds",
      value: function getFetchedMessageIds() {
        return this.fetchedMessages.map(function (messageInfo) {
          return messageInfo.metadata.messageId;
        });
      }
    }]);
    return EmbeddedMessagingProcessor;
  }();
});